import classNames from 'classnames';
import { Button, FlexContainer, Txt } from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { tdsLink } from 'config';
import { useTenancy } from 'state';
import styles from './TodoItemTenancyDepositProtection.module.scss';

/**
 * TodoItemTenancyDeposit
 *
 * @return {JSX.Element}
 */
const TodoItemTenancyDepositProtection = ({ className }) => {
  const [isLoading] = useState(false);
  const tenancyDoc = useTenancy();

  const handlerPayDepositToTDS = () => {
    // setIsLoading(true);
    // tenancyViewState
    //   .registerDeposit(tenancyData.tenancyUid)
    //   .finally(() => setIsLoading(false));
  };

  const isDone = tenancyDoc.depositProtected;

  return (
    <FlexContainer
      className={classNames(
        styles.TodoItemTenancyDeposit,
        className,
        TodoItemTenancyDepositProtection.displayName
      )}
      column
      gap
    >
      {isDone ? (
        <>
          <Txt bold>Deposit is registered and protected 🎉</Txt>
          <Txt regular>
            Congratulations the deposit has been successfully registered and
            protected with TDS (TDS Custodial Ltd).
          </Txt>
          <a
            href={tdsLink}
            target="_blank"
            className={styles.ButtonLink}
            rel="noreferrer"
          >
            <Button success flex>
              What is TDS?
            </Button>
          </a>
        </>
      ) : (
        <>
          <Txt bold>⚠️ Legally required</Txt>
          <Txt regular>
            For a tenancy to be compliant the deposit needs to be registered
            then paid into a government approved tenancy deposit scheme.
          </Txt>
          <Txt regular>
            Propa partners with TDS (TDS Custodial Ltd) to allow you to register
            the deposit and pay directly to TDS without any fees.
          </Txt>
          <a
            href={tdsLink}
            target="_blank"
            className={styles.ButtonLink}
            rel="noreferrer"
          >
            <Button success flex>
              What is TDS?
            </Button>
          </a>
          <Txt regular>Follow the steps below to complete:</Txt>
          <Txt regular>
            1. Register the deposit in the 'Deposit Registration' todo.
          </Txt>
          <Txt regular>2. Pay the deposit to TDS using the below button.</Txt>
          <Button
            flex
            success
            onClick={handlerPayDepositToTDS}
            disabled={isLoading}
          >
            Pay Deposit to TDS
          </Button>
        </>
      )}
    </FlexContainer>
  );
};

TodoItemTenancyDepositProtection.displayName =
  'TodoItemTenancyDepositProtection';

export default observer(TodoItemTenancyDepositProtection);
